export enum QaroniMatDialogAnimationToEnum {
  ASIDE = 'ASIDE',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP = 'TOP',
}

export type QaroniMatDialogAnimationToType =
  | QaroniMatDialogAnimationToEnum.ASIDE
  | QaroniMatDialogAnimationToEnum.TOP
  | QaroniMatDialogAnimationToEnum.BOTTOM
  | QaroniMatDialogAnimationToEnum.LEFT
  | QaroniMatDialogAnimationToEnum.RIGHT;
